/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  Comment,
  CommentReply,
  EntityId,
  List,
  OrganizationMember,
  PostCommentReplySchema,
  PostCommentSchema,
  UpdateCommentReplySchema,
  UpdateCommentSchema,
} from "./data-contracts";

/**
 * @description Returns a paginated list of comments posted directly on the space (not inside a change request). To read replies to a specific comment, use the comment replies endpoint.
 * @tags space-comments, critical
 * @name ListCommentsInSpace
 * @summary List all top-level comments posted on a space
 * @request GET:/spaces/{spaceId}/comments
 * @secure
 */

// @ts-ignore
export const listCommentsInSpace: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * An order for the items in the list
     * @default "desc"
     */
    order?: "asc" | "desc";
    /**
     * When provided, only comments with the given status are returned. Defaults to "all".
     * @default "all"
     */
    status?: "all" | "open" | "resolved";
    /** Output format for the content. */
    format?: "document" | "markdown";
    /** The target page of the comment */
    targetPage?: string;
    /** User IDs to filter queried comments on */
    authors?: string[];
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Comment[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/comments",
  method: "get",
  streaming: false,
  tags: ["space-comments", "critical"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * @description Creates a new top-level comment on the space, optionally anchored to a specific page or a text selection within a page. Use this to leave feedback, start a review thread, or annotate content. To reply to an existing comment, use the comment replies endpoint.
 * @tags space-comments
 * @name PostCommentInSpace
 * @summary Post a new comment on a space or a specific page
 * @request POST:/spaces/{spaceId}/comments
 * @secure
 */

// @ts-ignore
export const postCommentInSpace: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {};
  RequestBody: PostCommentSchema;
  RequestHeaders: {};
  ResponseBody: Comment;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/comments",
  method: "post",
  streaming: false,
  tags: ["space-comments"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a specific comment posted on a space. To list all comments in a space, use the space comments list endpoint.
 * @tags space-comments
 * @name GetCommentInSpace
 * @summary Get a single comment from a space by its ID
 * @request GET:/spaces/{spaceId}/comments/{commentId}
 * @secure
 */

// @ts-ignore
export const getCommentInSpace: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the comment */
    commentId: EntityId;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Comment;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/comments/{commentId}",
  method: "get",
  streaming: false,
  tags: ["space-comments"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-comments
 * @name DeleteCommentInSpace
 * @summary Delete a space comment
 * @request DELETE:/spaces/{spaceId}/comments/{commentId}
 * @secure
 */

// @ts-ignore
export const deleteCommentInSpace: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the comment */
    commentId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/spaces/{spaceId}/comments/{commentId}",
  method: "delete",
  streaming: false,
  tags: ["space-comments"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Updates the content or resolution status of an existing comment on a space. Only the comment author or a space admin can update a comment. Use this to edit a comment's text, mark it as resolved, or reopen it.
 * @tags space-comments
 * @name UpdateCommentInSpace
 * @summary Update the body or status of a space comment
 * @request PUT:/spaces/{spaceId}/comments/{commentId}
 * @secure
 */

// @ts-ignore
export const updateCommentInSpace: {
  route: string;
  method: "put";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the comment */
    commentId: EntityId;
  };
  RequestQuery: {};
  RequestBody: UpdateCommentSchema;
  RequestHeaders: {};
  ResponseBody: Comment;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/comments/{commentId}",
  method: "put",
  streaming: false,
  tags: ["space-comments"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Creates a reply to an existing comment on a space. Use this to continue a discussion thread started by a top-level comment. To start a new thread, use the space comment creation endpoint instead.
 * @tags space-comments
 * @name PostCommentReplyInSpace
 * @summary Post a reply to an existing space comment
 * @request POST:/spaces/{spaceId}/comments/{commentId}/replies
 * @secure
 */

// @ts-ignore
export const postCommentReplyInSpace: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the comment */
    commentId: EntityId;
  };
  RequestQuery: {};
  RequestBody: PostCommentReplySchema;
  RequestHeaders: {};
  ResponseBody: CommentReply;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/comments/{commentId}/replies",
  method: "post",
  streaming: false,
  tags: ["space-comments"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a specific reply to a comment in a space. To list all replies for a comment, use the comment replies list endpoint.
 * @tags space-comments
 * @name GetCommentReplyInSpace
 * @summary Get a single reply to a space comment by its ID
 * @request GET:/spaces/{spaceId}/comments/{commentId}/replies/{commentReplyId}
 * @secure
 */

// @ts-ignore
export const getCommentReplyInSpace: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the comment */
    commentId: EntityId;
    /** The unique id of the comment reply */
    commentReplyId: EntityId;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: CommentReply;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/comments/{commentId}/replies/{commentReplyId}",
  method: "get",
  streaming: false,
  tags: ["space-comments"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Updates the content of an existing reply to a comment in a space. Only the reply author or a space admin can update the reply. To update the parent comment, use the space comment update endpoint.
 * @tags space-comments
 * @name UpdateCommentReplyInSpace
 * @summary Update the body of a reply to a space comment
 * @request PUT:/spaces/{spaceId}/comments/{commentId}/replies/{commentReplyId}
 * @secure
 */

// @ts-ignore
export const updateCommentReplyInSpace: {
  route: string;
  method: "put";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the comment */
    commentId: EntityId;
    /** The unique id of the comment reply */
    commentReplyId: EntityId;
  };
  RequestQuery: {};
  RequestBody: UpdateCommentReplySchema;
  RequestHeaders: {};
  ResponseBody: CommentReply;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/comments/{commentId}/replies/{commentReplyId}",
  method: "put",
  streaming: false,
  tags: ["space-comments"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-comments
 * @name DeleteCommentReplyInSpace
 * @summary Delete a space comment reply
 * @request DELETE:/spaces/{spaceId}/comments/{commentId}/replies/{commentReplyId}
 * @secure
 */

// @ts-ignore
export const deleteCommentReplyInSpace: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the comment */
    commentId: EntityId;
    /** The unique id of the comment reply */
    commentReplyId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/spaces/{spaceId}/comments/{commentId}/replies/{commentReplyId}",
  method: "delete",
  streaming: false,
  tags: ["space-comments"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a paginated list of organization members who have posted at least one comment in the space. Use this to identify participants in a space's review or annotation workflow. For the actual comment content, use the space comments endpoint.
 * @tags space-comments, critical
 * @name ListCommentersInSpace
 * @summary List all users who have posted comments in a space
 * @request GET:/spaces/{spaceId}/commenters
 * @secure
 */

// @ts-ignore
export const listCommentersInSpace: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: OrganizationMember[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/commenters",
  method: "get",
  streaming: false,
  tags: ["space-comments", "critical"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "high",
  deprecated: false,
};
